import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughVoicemailProps = {
  node: ConversationFlowAuditLogEntry<'VOICE_MAIL_NODE_VISITED'>;
};

export function RoutedThroughVoicemail({
  node,
}: RoutedThroughVoicemailProps): JSX.Element {
  return (
    <>
      Voicemail · Added to queue <strong>{node.queue_name}</strong>
    </>
  );
}
